import React from 'react';

export const Progress = ({ value, className, ...props }) => {
  return (
    <div
      className={`progress bg-gris-piedra w-full h-2 rounded-full ${className}`}
      {...props}
    >
      <div
        className="progress-bar bg-azul-lago h-full rounded-full"
        style={{ width: `${value}%` }}
      ></div>
    </div>
  );
};
